import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Container, Card, Button, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import './StudentProfile.scss';

export default function StudentProfile() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [student, setStudent] = useState(location.state?.student || null);

  useEffect(() => {
    if (!student) {
      navigate('/dashboard');
    }
  }, [student, navigate]);

  if (!student) return null;

  return (
    <Container className="vintage-student-profile py-4">
      <Button
        variant="link"
        onClick={() => navigate(-1)}
        className="mb-3 ps-0 text-decoration-none back-link"
      >
        &larr; Zurück
      </Button>

      <Card className="profile-card shadow-sm">
        <Card.Body>
          <Row className="align-items-center">
            {/* Avatar */}
            <Col xs={12} md={2} className="text-center mb-3 mb-md-0">
              <div className="profile-avatar">
                {(student.name || student.vollerName || '?')[0].toUpperCase()}
              </div>
            </Col>

            {/* Info */}
            <Col xs={12} md={7}>
              <h1 className="profile-name">
                {student.name || student.vollerName || 'Unbekannt'}
              </h1>
              <div className="d-flex align-items-center mb-2">
                <p className="profile-role mb-0 me-2">Lernende Person</p>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="student-info-tooltip">
                      Diese Person ist als Lernende/r registriert. Die Profilseite dient dazu, 
                      einen Chat zu eröffnen oder organisatorische Fragen zu klären.
                    </Tooltip>
                  }
                >
                  <div style={{ cursor: 'pointer', color: '#b95c50', display: 'flex', alignItems: 'center' }}>
                    <i className="bi bi-question-circle" style={{ fontSize: '1rem' }}></i>
                  </div>
                </OverlayTrigger>
              </div>
              <p className="profile-email">{student.email || 'Keine E-Mail angegeben'}</p>
            </Col>

            {/* Aktionen */}
            <Col xs={12} md={3} className="text-md-end mt-3 mt-md-0">
              <Button
                className="chat-button"
                onClick={() => navigate(`/chat/${id}`)}
              >
                Chat eröffnen
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}
